// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6GkiP","col":"styles_col__331bk"};